import { Project, ProcoreProject } from 'Projects/Types/types'

export type ProjectsState = {
  projectList: Project[]
  procoreProjects: ProcoreProject[]
  loading: boolean
  procoreLoading: boolean
  error: string
}

const initialState = {
  projectList: [],
  procoreProjects: [],
  loading: false,
  procoreLoading: false,
  error: ''
}

export default initialState
